import React, { Component } from "react";
import Slider from "./slider";
import SliderHorizontal from "./slider-horizontal";
class ProductSelectors extends Component {
  constructor(props) {
    super(props);

    this.state = {
      typeSelected: "Anatomisk",
      surfaceSelected: "Alla",
      widthSelected: "Alla",
      heightSelected: "Alla",
      projSelected: "Alla",
      surfaceSelectedId: 0,
      widthSelectedId: 0,
      heightSelectedId: 0,
      projSelectedId: 0
    };

    this.fields = {
      heightVal: {
        Alla: false,
        Low: { max: 10 },
        Medium: { min: 10, max: 13 },
        Tall: { min: 13 }
      },

      projVal: {
        Alla: false,
        Moderate: { max: 5 },
        "Moderate+": { min: 5, max: 9 },
        High: { min: 9 }
      }
    };

    this.handleWidthChange = this.handleWidthChange.bind(this);
    this.handleHeightChange = this.handleHeightChange.bind(this);
    this.handleProjChange = this.handleProjChange.bind(this);
    this.filterResults();
  }

  componentDidMount() {
    setTimeout(() => {
      this.filterResults();
    }, 500);
  }

  onlyUnique(value, index, self) {
    return self.indexOf(value) === index && value.length > 0;
  }

  handleWidthChange(event) {
    this.setState({ widthSelected: event.target.value }, () => {
      this.filterResults();
    });
  }

  handleHeightChange(event) {
    this.setState({ heightSelected: event.target.value }, () => {
      this.filterResults();
    });
  }

  handleProjChange(event) {
    this.setState({ projSelected: event.target.value }, () => {
      this.filterResults();
    });
  }

  populateOptions(options) {
    return options.map((option, index) => {
      return (
        <option key={index} value={option}>
          {option}
        </option>
      );
    });
  }

  filterResults() {
    const {
      typeSelected,
      widthSelected,
      heightSelected,
      projSelected,
      surfaceSelected
    } = this.state;
    const allFields = this.props.productList;
    // let heightFilter = this.fields.heightVal[heightSelected];
    // let projFilter = this.fields.projVal[projSelected];

    //let typeItems = allFields.filter(({ Type }) => Type === typeSelected);

    let typeItems = allFields.filter(({ Type }) => {
      if (typeSelected === "Alla") return true;
      return Type === typeSelected;
    });

    let filtered = typeItems.filter(field => {
      if (widthSelected === "Alla") return true;
      return field["Width cm"] === widthSelected;
    });

    let filtered2 = filtered.filter(field => {
      if (heightSelected === "Alla") return true;
      return field["Height"] === heightSelected;
    });

    let filtered3 = filtered2.filter(field => {
      if (projSelected === "Alla") return true;
      return field["Projection"] === projSelected;
    });

    let filtered4 = filtered3.filter(field => {
      if (surfaceSelected === "Alla") return true;
      return field["Surface"] === surfaceSelected;
    });

    //let filtered2 = this.selfilter(filtered, heightFilter, 'Height cm');
    //let filtered3 = this.selfilter(filtered2, projFilter, 'Projection cm');

    this.props.handleResult(filtered4);
  }

  selfilter(raw, obj, value) {
    return raw.filter(function(data) {
      const numb = Number(data[value].replace(/[^0-9.]/g, ""));
      const min = obj["min"];
      const max = obj["max"];

      if (max && min) {
        return min <= numb && max >= numb ? true : false;
      } else if (typeof max !== "undefined") {
        return max >= numb ? true : false;
      } else if (typeof min !== "undefined") {
        return min <= numb ? true : false;
      } else {
        return true;
      }
    });
  }

  onGaugeChange = (id, value, SelectedId) => {
    let Selected = id.replace(/Selected/, "SelectedId");
    this.setState({ [id]: value, [Selected]: SelectedId }, () => {
      this.filterResults();
    });
  };

  handleTypeClick = ({ target: { value } }) => {
    this.setState(
      {
        typeSelected: value,
        surfaceSelected: "Alla",
        widthSelected: "Alla",
        heightSelected: "Alla",
        projSelected: "Alla",
        surfaceSelectedId: 0,
        widthSelectedId: 0,
        heightSelectedId: 0,
        projSelectedId: 0
      },
      () => {
        this.filterResults();
      }
    );
  };

  render() {
    const products = this.props.productList;

    if (products.length === 0) {
      return <h3>Fetching Data...</h3>;
    } else {
      let gougeFilter1 = products.filter(
        ({ Type }) =>
          (Type === this.state.typeSelected) |
          (this.state.typeSelected === "Alla" && Type.length > 0)
      );

      let implantWidth = gougeFilter1
        .map(arr => arr["Width cm"])
        .sort(
          (a, b) =>
            Number(String(a).replace(/,/, ".")) -
            Number(String(b).replace(/,/, "."))
        )
        .filter(this.onlyUnique);
      implantWidth.unshift("Alla");

      let implantHeight = gougeFilter1
        .map(arr => arr["Height"])
        .filter(this.onlyUnique)
        .filter(a => a !== "-")
        .sort();
      implantHeight.unshift("Alla");

      let implantSurfaces = gougeFilter1
        .map(arr => arr["Surface"])
        .filter(this.onlyUnique)
        .filter(a => a !== "-")
        .sort();
      implantSurfaces.unshift("Alla");

      let implantProjection = gougeFilter1
        .map(arr => arr["Projection"])
        .filter(a => a !== "-")
        .filter(this.onlyUnique)
        .sort();
      implantProjection.unshift("Alla");

      // //const implantHeight = 'Alla,Low,Medium,Tall'.split(',');
      const implantTypes = [
        ...new Set(products.map(({ Type }) => Type).filter(e => e.length > 0))
      ];
      implantTypes.unshift("Alla");

      // const implantSurfaces = 'Alla,Slät,Smooth,Siltex'.split(',');
      // const implantProjection = 'Alla,HP,M+,MP,UHP'.split(',');

      return (
        <div className="product-selector">
          <h2 className="section-header" style={{ textAlign: "center" }}>
            Välkommen till storleksväljaren!
          </h2>

          <div className="paragraf">
            <p style={{ textAlign: "center" }}>
              Välj höjd, bredd eller projektion för att snäva in urvalet av
              implantat som finns att tillgå.
            </p>
          </div>
          <br />
          <br />
          <div className="product-types">
            <button
              value="Anatomisk"
              className={`ui button product-type${
                this.state.typeSelected === "Anatomisk" ? " active" : ""
              } `}
              onClick={this.handleTypeClick}
            >
              Anatomisk
            </button>
            <button
              value="Rund"
              className={`ui button product-type${
                this.state.typeSelected === "Rund" ? " active" : ""
              }`}
              onClick={this.handleTypeClick}
            >
              Rund
            </button>
            <button
              value="Rund Xtra"
              className={`ui button product-type${
                this.state.typeSelected === "Rund Xtra" ? " active" : ""
              }`}
              onClick={this.handleTypeClick}
            >
              Rund Xtra
            </button>
            <button
              value="Expander"
              className={`ui button product-type${
                this.state.typeSelected === "Expander" ? " active" : ""
              }`}
              onClick={this.handleTypeClick}
            >
              Expander
            </button>
          </div>
          <div className="product-sliders">
            {/* <Slider
              label="Typ"
              data={implantTypes}
              name="typeSelected"
              onChange={this.onGaugeChange}
              value={this.state.typeSelected}
            /> */}

            <form className="ui form">
              <div className="two fields">
                <div className="field">
                  <SliderHorizontal
                    label="Bredd"
                    data={implantWidth}
                    name="widthSelected"
                    selectedId={this.state.widthSelectedId}
                    onChange={this.onGaugeChange}
                    value={this.state.heightSelected}
                  />
                </div>

                <div className="field">
                  <SliderHorizontal
                    label="Höjd"
                    data={implantHeight}
                    name="heightSelected"
                    selectedId={this.state.heightSelectedId}
                    onChange={this.onGaugeChange}
                    value={this.state.heightSelected}
                  />
                </div>
              </div>{" "}
              <div className="two fields">
                <div className="field">
                  <SliderHorizontal
                    label="Projektion"
                    data={implantProjection}
                    name="projSelected"
                    selectedId={this.state.projSelectedId}
                    onChange={this.onGaugeChange}
                    value={this.state.heightSelected}
                  />
                </div>
                <div className="field">
                  <SliderHorizontal
                    label="Yta"
                    data={implantSurfaces}
                    name="surfaceSelected"
                    selectedId={this.state.surfaceSelectedId}
                    onChange={this.onGaugeChange}
                    value={this.state.heightSelected}
                  />
                </div>
              </div>
            </form>
            {/* 
            <Slider
              label="Bredd"
              data={implantWidth}
              name="widthSelected"
              onChange={this.onGaugeChange}
              value={this.state.widthSelected}
              unit={"cm"}
            />
            <Slider
              label="Höjd"
              data={implantHeight}
              name="heightSelected"
              onChange={this.onGaugeChange}
              value={this.state.heightSelected}
            />
            <Slider
              label="Projektion"
              data={implantProjection}
              name="projSelected"
              onChange={this.onGaugeChange}
              value={this.state.projSelected}
            />
            <Slider
              label="Yta"
              data={implantSurfaces}
              name="surfaceSelected"
              onChange={this.onGaugeChange}
              value={this.state.surfaceSelected}
            /> */}
          </div>
        </div>
      );
    }
  }
}

export default ProductSelectors;
